import PetDocUpload from './petdoc-upload'

export default PetDocUpload